import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import dealersActions from '../../redux/dealers/actions';

export default ChildComponent => {
  class ContentPage extends Component {
    componentDidMount() {
      const { dealer, match } = this.props;
      const { dealerId } = match.params;
      if (dealerId && (!dealer.id || dealer.id !== dealerId)) {
        this.props.contentActions.dealerRequest({ dealerId });
      }
    }
    render() {
      return <ChildComponent {...this.props} />;
    }
  }

  ContentPage.propTypes = {
    match: PropTypes.object,
    dealer: PropTypes.object,
    contentActions: PropTypes.object,
  };

  const mapStateToProps = ({ dealers }) => ({
    dealer: dealers.dealer,
  });

  const mapDispatchToProps = dispatch => ({
    contentActions: bindActionCreators(dealersActions, dispatch),
  });

  return connect(mapStateToProps, mapDispatchToProps)(ContentPage);
};
